import type {DataRouterBlobPayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {fileTreeQuery} from '../queries/file-tree-query'

export const codeViewBlobRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewBlobRoute', {
  path: '/:owner/:repo/blob/:branch/*',
  queries: [
    mainQuery<DataRouterBlobPayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams}),
      encodeFetchPath: true,
    }),
    fileTreeQuery,
  ],
})
